export const borealisTheme = {
  borders: [
    0,
    '1px solid',
    '2px solid',
    '4px solid',
    '8px solid',
    '16px solid',
    '32px solid',
  ],
  borderRadiuses: ['2px', '4px', '8px', '50%'],
  breakPoints: ['426px', '600px', '768px', '992px', '1280px', '1600px'],
  fontSizesFluid: [
    'calc(12.8px + (17.92 - 12.8) * ((100vw - 426px) / (1600 - 426)))',
    'calc(16px + (22.4 - 16) * ((100vw - 426px) / (1600 - 426)))',
    'calc(20px + (28 - 20) * ((100vw - 426px) / (1600 - 426)))',
    'calc(25.6px + (35.84 - 25.6) * ((100vw - 426px) / (1600 - 426)))',
    'calc(38.4px + (53.76 - 38.4) * ((100vw - 426px) / (1600 - 426)))',
    'calc(48px + (67.2 - 48) * ((100vw - 426px) / (1600 - 426)))',
    'calc(96px + (134.4 - 96) * ((100vw - 426px) / (1600 - 426)))',
  ],
  lineHeightsFluid: [
    'calc(15.2px + (21.28 - 15.2) * ((100vw - 426px) / (1600 - 426)))',
    'calc(19px + (26.6 - 19) * ((100vw - 426px) / (1600 - 426)))',
    'calc(23.75px + (33.25 - 23.75) * ((100vw - 426px) / (1600 - 426)))',
    'calc(30.4px + (42.56 - 30.4) * ((100vw - 426px) / (1600 - 426)))',
    'calc(45.6px + (63.84 - 45.6) * ((100vw - 426px) / (1600 - 426)))',
    'calc(57px + (79.8 - 57) * ((100vw - 426px) / (1600 - 426)))',
    'calc(114px + (159.6 - 114) * ((100vw - 426px) / (1600 - 426)))',
  ],
  lineHeights: [18, 21, 24, 30, 36, 48, 60, 72],
  fontSizes: [12, 14, 16, 20, 24, 32, 40, 48],
  fontWeights: {
    300: 'light',
    400: 'normal',
    600: 'bold',
    light: 300,
    normal: 400,
    bold: 600,
  },
  space: [0, 4, 8, 16, 24, 32, 40, 48, 64, 80, 96, 112, 128],
  shadows: [
    '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
    '0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22)',
  ],
  colors: {
    black: '#000',
    white: '#fff',
    transparent: 'transparent',
    blacks: [
      'rgba(0, 0, 0, 0.80)',
      'rgba(0, 0, 0, 0.65)',
      'rgba(0, 0, 0, 0.50)',
      'rgba(0, 0, 0, 0.30)',
      'rgba(0, 0, 0, 0.15)',
      'rgba(0, 0, 0, 0.09)',
      'rgba(0, 0, 0, 0.04)',
      'rgba(0, 0, 0, 0.02)',
    ],
    whites: [
      'rgba(255, 255, 255, 1)',
      'rgba(255, 255, 255, 0.8)',
      'rgba(255, 255, 255, 0.65)',
      'rgba(255, 255, 255, 0.5)',
      'rgba(255, 255, 255, 0.3)',
      'rgba(255, 255, 255, 0.15)',
      'rgba(255, 255, 255, 0.09)',
      'rgba(255, 255, 255, 0.04)',
    ],
    darkblue: [
      '#8a9499',
      '#5a7a8c',
      '#3d6580',
      '#255173',
      '#103e66',
      '#002d5a',
      '#001833',
      '#00060d',
      '#000000',
      '#000000',
    ],
    blue: [
      '#c3d4d9',
      '#83b8cc',
      '#5ca1bf',
      '#398ab3',
      '#1b73a6',
      '#005d9a',
      '#004173',
      '#00294d',
      '#001326',
      '#000000',
    ],
    lightblue: [
      '#e6fcff',
      '#a3f3ff',
      '#77e2f7',
      '#4bcbeb',
      '#23b2de',
      '#0099d2',
      '#0078ab',
      '#005885',
      '#003c5e',
      '#002238',
    ],
    red: [
      '#ffeae6',
      '#ffafa3',
      '#f78477',
      '#eb564b',
      '#de2a23',
      '#d10000',
      '#ab0006',
      '#850009',
      '#5e0009',
      '#380007',
    ],
    orange: [
      '#fff7e8',
      '#ffe6bf',
      '#ffd296',
      '#ffbb6e',
      '#fa9f43',
      '#ee7e1a',
      '#c75d0c',
      '#a14102',
      '#7a2d00',
      '#541c00',
    ],
    lightorange: [
      '#fffce6',
      '#fff3a3',
      '#ffe97a',
      '#ffdc52',
      '#ffcd29',
      '#fab900',
      '#d49400',
      '#ad7400',
      '#875600',
      '#613a00',
    ],
    yellow: [
      '#feffe6',
      '#fdffa3',
      '#fffd7a',
      '#fff652',
      '#ffed29',
      '#ffe100',
      '#d9b800',
      '#b39200',
      '#8c6e00',
      '#664d00',
    ],
    green: [
      '#eff0e1',
      '#dfe3b1',
      '#cdd685',
      '#b9c95d',
      '#a4bd39',
      '#91b119',
      '#6a8a0c',
      '#486304',
      '#2a3d00',
      '#0f1700',
    ],
    lightgreen: [
      '#fffcf0',
      '#fffbe0',
      '#f7f0b2',
      '#ebe483',
      '#ded959',
      '#d2d232',
      '#a6ab20',
      '#7d8513',
      '#565e08',
      '#313804',
    ],
    gray: [
      '#ffffff',
      '#f2f2f2',
      '#e6e6e6',
      '#d9d9d9',
      '#cccccc',
      '#bfbfbf',
      '#999999',
      '#737373',
      '#4d4d4d',
      '#262626',
    ],
    state: {
      error: '#d10000',
      warning: '#ee7e1a',
      success: '#91b119',
      info: '#0099d2',
    },
    primary: '#002d5a',
    secondary: '#005d9a',
    tertiary: '#0099d2',
    bodytext: '#002d5a',
  },
  gradients: {
    blueToWhite:
      'linear-gradient(96deg, rgb(0, 93, 154) 25%, rgb(0, 163, 210) 45%, rgb(91, 197, 241) 55%, rgb(255, 255, 255) 75%);',
    blue:
      'linear-gradient(96deg, rgb(0, 45, 90) 0%, rgb(0, 93, 154) 25%, rgb(0, 153, 210) 60%, rgb(130, 207, 245) 100%);',
  },
  fonts: {
    primary: 'Arial',
    secondary: 'Roboto',
  },
};

export const customTheme = {
  ...borealisTheme,
  colors: {
    ...borealisTheme.colors,
    primary: borealisTheme.colors.secondary,
    secondary: '#767676',
    background: '#F9F9F9',
    darkFocus: '#D9EAF6',
    focus: '#F5F9FD',
    focusDark: borealisTheme.colors.darkblue[6],
    borderFocus: borealisTheme.colors.lightblue[2],
    lightGray: '#EEEEEE',
    green: '#539f00',
    lightGreen: '#f0f6e9',
    grayText: '#939393',
    gray: '#c3c3c3',
    darkerGray: '#7f7f7f',
    black: '#1d1e1f',
    lighterBlack: '#3b3b3b',
    darkerWhite: '#CCC',
  },
  breakPoints: borealisTheme.breakPoints.map(
    breakPoint => `${Number(breakPoint.replace(/\D/g, '')) + 1}px`
  ),
  space: [
    ...borealisTheme.space, // Ends at 128
    256,
  ],
  // customize the default theme here
};
